import { Category } from '@modules/husleie-framework/src/enums/Category.enum';
import { LandlordTypeEnum } from '@modules/husleie-framework/src/types/Landlord.entity';
import { SessionTypeEnum } from '@modules/husleie-framework/src/types/Session.entity';
import type SessionState from '@modules/store/session/types/SessionState.entity';

export const state: SessionState = {
  loading: false,
  loaded: false,
  apiError: false,
  signingMethods: [],
  signingUuid: '',
  landlordSignerUuid: '',
  inspectionReport: {
    uuid: '',
    type: SessionTypeEnum.MOVE_IN,
    status: null,
    landlord: {
      id: null,
      type: LandlordTypeEnum.PRIVATE,
    },
    tenant: undefined,
    coTenants: [],
    rentalObject: {
      category: Category.APARTMENT,
      rooms: [],
      keychain: {
        keys: [],
        images: [],
        comment: '',
      },
      utilities: [],
      details: {},
      comment: '',
    },
    comment: '',
    images: [],
    preview: {},
  },
};
